export const nepMonths = [
  "Baishak",
  "Jestha",
  "Aasad",
  "Shrawan",
  "Bhadra",
  "Aaswin",
  "Kartik",
  "Mangsir",
  "Paush",
  "Magh",
  "Falgun",
  "Chaitra",
];

export const engMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
